<template>
    <div class="home-cover">
        <b-skeleton-img
            v-if="!homeSection.exists"
            no-aspect
            height="250px"
        />

        <b-img
            v-else
            class="cover-img"
            :src="cover"
        />
    </div>
</template>

<script>
    import './HomeCover.scss';
    import './HomeCover.mobile.scss';
    import LandingPageHomeSectionAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageHomeSectionAppResource";
    import {HOME_IMAGES} from "../../../../helpers/images";

    export default {
        name: 'HomeCover',

        components: {},

        props: {
            homeSection: {
                type: LandingPageHomeSectionAppResource,
                required: true,
            },
            isMobile: {
                type: Boolean,
                required: true,
            },
        },

        computed: {
            cover() {
                return (this.homeSection.cover || {}).publicStorageUrl || HOME_IMAGES.DEFAULT_COVER;
            },
        },
    };
</script>
